import React, { useEffect } from 'react';

// Default time slots if none are provided
const defaultTimeSlots = [
  '08:00', '09:00', '10:00', '11:00', '14:00', '15:00', '16:00', '17:00'
];

interface TimeSlotsProps {
  selectedTime: string | null;
  setSelectedTime: (time: string) => void;
  availableTimeSlots?: string[];
}

const TimeSlots: React.FC<TimeSlotsProps> = ({ 
  selectedTime, 
  setSelectedTime,
  availableTimeSlots = defaultTimeSlots
}) => {
  // Log para debug quando os horários disponíveis mudam
  useEffect(() => {
    console.log('TimeSlots: Horários disponíveis recebidos:', availableTimeSlots);
  }, [availableTimeSlots]);

  // Handler para quando um horário é selecionado
  const handleTimeSelect = (time: string) => {
    console.log('TimeSlots: Horário selecionado:', time);
    setSelectedTime(time);
  };

  return (
    <div className="mt-2 sm:mt-4 md:mt-[24px]">
      <h3 className="text-sm sm:text-base md:text-[16px] font-semibold text-white mb-2 sm:mb-3 md:mb-[16px]">Horários disponíveis</h3>
      {availableTimeSlots.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3 md:gap-[12px]">
          {availableTimeSlots.map((time) => (
            <button
              key={time}
              onClick={() => handleTimeSelect(time)}
              className={`time-slot h-9 sm:h-10 md:h-[40px] flex items-center justify-center rounded-[8px] border text-xs sm:text-sm md:text-[14px] font-medium transition-colors ${
                selectedTime === time 
                  ? 'bg-[#1777CF] text-white border-[#1777CF]' 
                  : 'text-white border-white/20 hover:border-[#FFFFFF] bg-white/5'
              }`}
            >
              {time}
            </button>
          ))}
        </div>
      ) : (
        <p className="text-white/70 text-sm">Nenhum horário disponível para esta data. Por favor, selecione outra data.</p>
      )}
    </div>
  );
};

export default TimeSlots;